import { PropTypes } from '../../dependencies';

export const errorPropType = PropTypes.shape({
    id: PropTypes.string,
    values: PropTypes.shape(),
});
